import {Box, css, styled} from '@mui/material';
import {StyledBoxProps} from './types';

export const StyledBox = styled(Box)<StyledBoxProps>`
	display: flex;
	flex-direction: column;
	gap: 16px;
	justify-content: center;
	align-items: center;

	${({$fullWidth}) =>
		$fullWidth &&
		css`
			width: 100%;
		`}

	${({$fullscreen}) =>
		$fullscreen &&
		css`
			background-color: ${({theme}) => theme.palette.background.paper};
			position: fixed;
			height: 100vh;
			width: 100vw;
			z-index: 2;
			left: 0;
			top: 0;
		`}
`;
